import {
  IRequirementsMandatoryNew,
  IStructuresUnit,
  IStructuresUnitsAsTreeResponse,
} from 'APIPackage/RequirementsNpaModule/interfaces/IStructuresUnitsAsTreeResponse';

/**
 * Функция для обновления data в узле дерева по его id
 * tree - исходное дерево
 * nodeId - id узла, который нужно обновить
 * newData - новые данные для узла
 * новое дерево с обновленными данными
 */
export const updateNodeDataById = (
  tree: IStructuresUnitsAsTreeResponse | undefined,
  nodeId: string,
  newData: IRequirementsMandatoryNew[],
) => {
  // Защитные проверки
  if (!tree) {
    return tree;
  }

  if (!tree.nodes || !Array.isArray(tree.nodes)) {
    return tree;
  }

  if (!nodeId) {
    return tree;
  }

  // Проверяем newData
  if (!newData || !Array.isArray(newData)) {
    return tree;
  }

  // Создаем глубокую копию объекта
  const updatedTree: IStructuresUnitsAsTreeResponse = JSON.parse(JSON.stringify(tree));

  // Вспомогательная функция для рекурсивного обхода дерева
  const traverse = (node: IStructuresUnit) => {
    if (!node) return;

    if (node.id === nodeId) {
      // Нашли нужный узел - обновляем его data
      // eslint-disable-next-line no-param-reassign
      node.data = newData;
      // Обновляем dataSize
      // eslint-disable-next-line no-param-reassign
      node.dataSize = newData ? newData.length : 0;

      return;
    }

    // Рекурсивно обходим дочерние узлы
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(child => {
        if (child) traverse(child);
      });
    }
  };

  // Обходим все узлы верхнего уровня
  updatedTree.nodes.forEach(node => {
    if (node) traverse(node);
  });

  return updatedTree;
};
